import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 px-4" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <FadeIn data-id="element-126">
          <div className="bg-[#FFF8F0] border-2 border-[#F5A623]/30 p-8 md:p-10 rounded-3xl text-center relative overflow-hidden" data-id="element-127">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#F5A623] to-[#E8604C]" data-id="element-128"></div>

            <Sparkles className="w-10 h-10 text-[#F5A623] mx-auto mb-6" data-id="element-129" />

            <p className="font-serif text-xl md:text-2xl text-[#2D2A26] leading-relaxed italic" data-id="element-130">
              "En solo 7 días, pasarás de ser un altavoz que repite órdenes al
              aire a ser un guía cuya voz tiene peso. No es magia, es
              neurociencia aplicada a la comunicación:{' '}
              <strong className="text-[#E8604C] font-bold" data-id="element-131">
                cuando dejas de ser ruido, ellos empiezan a escuchar.
              </strong>
              "
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}